import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface AbstractsGroupUpdateData {
    gradingGroupId?: number;
}

export class AbstractsGroupUpdate implements FormValidationModel<AbstractsGroupUpdateData> {
    public data: AbstractsGroupUpdateData;
    public rules: yup.Schema<AbstractsGroupUpdateData>;

    public constructor() {
        this.data = {
            gradingGroupId: undefined,
        };
        this.rules = yup.object<AbstractsGroupUpdateData>().shape({
            gradingGroupId: yup.number().label("Grading group").notOneOf([null, undefined], "Please select a valid grading group"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractsGroupUpdate.ts